import React, { Component } from 'react'
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import loginlogo from '../login-logo.png';
import configData from '../configData.json';
import { useRef } from 'react';

export default function AuthenticationVerify() {
    const [userDetails, setUserDetails] = useState({});
    const [loading, setLoading] = useState(false);

    let userDetailsRef = useRef({});
    userDetailsRef.current = userDetails;

    const navigate = useNavigate();
    const location = useLocation();

    // Access loginData from location state
    const loginData = location.state ? location.state.loginData : null;

    // Function to mask email address
    // const maskEmail = (email) => {
    //     const [username, domain] = email.split('@');
    //     const maskedUsername = username.length > 4 ? username.slice(0, 2) + '*'.repeat(username.length - 4) + username.slice(-2) : username;
    //     return `${maskedUsername}@${domain}`;
    // };

    // Function to mask email address
const maskEmail = (email) => {
    const [username, domain] = email.split('@');
    let maskedUsername;

    if (username.length > 4) {
        maskedUsername = username.slice(0, 2) + '*'.repeat(username.length - 4) + username.slice(-2);
    } else {
        debugger;
        // Handle the * accordingly in the else part
        maskedUsername = username.length > 1 ? username[0] + '*'.repeat(username.length - 2) + username.slice(-1) : '*';
    }

    return `${maskedUsername}@${domain}`;
};


    const sendAuthCode = async () => {
        debugger;
        setLoading(true);
        let email = loginData.email;
        const URL = `${configData.BASE_APP_URL}Login/requesttwostepauthenticationtoken?email=${email}`;
        try {
            const resp = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    Authorization: loginData.token,
                },
            });

            debugger;
            if (resp.ok) {
                navigate('/AuthenticationOtp', {
                    state: {
                        loginData: loginData,
                    },
                });

            } else if (resp.status === 400) {
                const errorData = await resp.json();
                document.getElementById("error").innerHTML = errorData.message;
            } else {
                const errorData = await resp.json();
                document.getElementById("error").innerHTML = errorData.message;
            }
        } catch (error) {
            // Handle errors here
            console.error('There was an error!', error);
        } finally {
            setLoading(false);
        }
    };

    const Loader = () => {
        return (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        )
    }

    return (
        <div className='login-container shadow-sm bg-body rounded border d-flex'>
            <div className='login-logo d-flex align-items-center justify-content-center p-3 rounded-start'>
                {<img src={loginlogo}></img>}
            </div>
            <div className='login-field d-flex align-items-center p-3'>
                <div>
                    <h5>Two Factor Authentication</h5>
                    <p className='mb-2'>Pick your authentication method</p>

                    <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id="inlineRadio1"
                            value="Y"
                            checked={true}
                        />
                        <label className="form-check-label" htmlFor="inlineRadio1">
                            Security Code via Email ({loginData ? maskEmail(loginData.email) : ''})
                        </label>
                    </div>

                    <div id="error" className="text-danger"></div>
                    <div className='d-grid gap-2'>

                        <button className="btn-login btn-block" type="button" onClick={sendAuthCode}>
                            {loading && <Loader />} {'  '}
                            Send Authentication Code
                        </button>

                    </div>

                    {/* <div className='text-center'>

                        <a href='#'>Cancel</a>

                    </div> */}

                </div>
            </div>
        </div>

    )
}
